import * as React from 'react';
import { SVGProps } from 'react';

const IconFlagFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 1H2v10h1V7h7L8 4l2-3z" />
  </svg>
);
export default IconFlagFilledSizeXs;
